// Entry point for the standalone /contact page — but deliberately NOT
// experience.js, since the contact page has no scroll experience.
//
// The shared theme, home-page chrome, waitlist form styling, and this page's own
// layout are linked from contact.html's <head> (not imported here) so they are
// render-blocking in dev and don't flash unstyled on refresh. Vite still runs
// them through the same pipeline (Tailwind, fonts, minification).

// --- Contact form behaviour (copied from ae-dyn-web/contact.html) ------------
// Character counter for the message field + Netlify Forms AJAX submit. Runs as a
// deferred module, so the DOM is parsed by the time this executes.
const form = document.getElementById('contact-form')
if (form) {
  const statusEl = document.getElementById('status')
  const sentEl = document.getElementById('sent')
  const button = form.querySelector('button[type="submit"]')
  const message = document.getElementById('message')
  const counter = document.getElementById('counter')
  const MAX_MESSAGE = 1000

  const updateCounter = () => {
    const n = message.value.length
    counter.textContent = `${n} / ${MAX_MESSAGE}`
    counter.classList.toggle('limit', n >= MAX_MESSAGE)
  }
  message.addEventListener('input', updateCounter)
  updateCounter()

  form.addEventListener('submit', (e) => {
    e.preventDefault()
    statusEl.classList.remove('error')
    statusEl.textContent = 'Sending…'
    button.disabled = true

    // Netlify Forms AJAX: POST url-encoded data back to the page path.
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(new FormData(form)).toString(),
    })
      .then((res) => {
        if (res.ok) {
          form.hidden = true
          sentEl.hidden = false
        } else {
          throw new Error('Something went wrong.')
        }
      })
      .catch((err) => {
        statusEl.classList.add('error')
        statusEl.textContent = `${err.message} You can also email contact@ae-dyn.com directly.`
        button.disabled = false
      })
  })
}
